module.exports = __webpack_public_path__ + "img/plano-pet.1f0a4f9c.jpeg";